import React from 'react'
import {useAuth0} from '@auth0/auth0-react'
import {PrimaryButton, SecondaryButton, ButtonRow, ModalTitle} from './styled'

const ThryvLeadsModal = ({close}) => {
  const {user} = useAuth0()
  const isReseller =
    user.user_roles.includes('reseller') || user.user_roles.includes('Reseller')

  const requestNewProposalLink = isReseller
    ? 'https://thryv.jotform.com/251764288362869'
    : 'https://thryv.jotform.com/211044041218035'

  const links = [
    {label: 'Request a New Proposal', href: requestNewProposalLink},
    {
      label: 'View My Proposals & Campaigns',
      href: 'https://dexyp.ldex.co/thryv-leads/sso/thryv',
    },
    {
      label: 'Submit Escalation, Change Request or Product Questions',
      href: 'https://thryv.jotform.com/211234077295050',
    },
    // {
    //   label: 'Thryv Leads Education & Support Appt - Budget less than $1500',
    //   href: 'https://emp.thryv.com/site/qvszlidphbhkxwcs/online-scheduling?service=c7z4daag176clttq',
    // },
    {
      label: 'LSA Guide',
      href: 'https://claude.ai/artifact/RzKHEZb8PGREBeoRUMDVPg?sk=yIomZRCaGC5ouDTIH0AO6w',
    },
  ]

  return (
    <div style={{width: '100%'}}>
      <ModalTitle>What do you want to do?</ModalTitle>
      <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
        {links.map(({label, href}) => (
          <ButtonRow key={href}>
            <PrimaryButton
              style={{width: '66%'}}
              onClick={() => window.open(href, '_blank')}
            >
              {label} &nbsp;
              <i
                className="fa fa-external-link-square-alt fa-fw"
                aria-hidden="true"
              />
            </PrimaryButton>
          </ButtonRow>
        ))}
        <ButtonRow>
          <SecondaryButton onClick={close}>Close</SecondaryButton>
        </ButtonRow>
      </div>
    </div>
  )
}

export default ThryvLeadsModal
